import { html } from 'lit';
import { Save } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-save')
export class PdsIconSave extends PdsIcon {
  @state()
  icon = Save;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
